import FinTronConfig from '@fintronners/react-config/src/Config/FinTronConfig';

export default {
  sorry: 'Sorry',
  oops: 'Oops!',
  existingUser:
    'It looks like you already have some information on file. For security reasons, a person can only have one username.',
  existingAccount:
    'It looks like some of your information is already on file. Try logging in to continue.',
  createUser: `We are unable to create your profile at this time. Please confirm all information is entered correctly. If this issue persists, please contact support at [${FinTronConfig.supportEmail}](${FinTronConfig.supportEmail}).`,
  createAccount: `We are unable to create your account at this time. Please confirm all information is entered correctly. If this issue persists, please contact support at [${FinTronConfig.supportEmail}](${FinTronConfig.supportEmail}).`,
  enrollPreferences:
    'Something went wrong saving your enrollment preferences. Please check your settings and try again. If the issue persists, please contact support.',
  required: 'This field is required',
  minLength: 'At least {{minLength}} characters',
  maxLength: 'At most {{maxLength}} characters',
  minAmount: 'At least ${{minAmount}}',
  maxAmount: 'At most ${{maxAmount}}',
  minPercentAmount: 'Percentage must be at least {{minAmount}}%',
  maxPercentAmount: 'Percentage must be less than {{maxAmount}}%',
  invalidUsername: 'Username cannot contain special characters',
  invalidSSNLength: 'SSN must be exactly 9 digits',
  invalidSSN: 'Invalid SSN',
  invalidCPFLength: 'CPF must be exactly 11 digits',
  invalidCPF: 'Invalid CPF',
  duplicateSSN: 'SSN already exists',
  duplicateEmail: 'Email is already in use',
  duplicatePhoneNumber: 'Phone number is already in use',
  passwordDoNotMatch: 'The passwords do not match',
  invalidPassword: 'Password must contain at least 1 special character (! @ # $…)',
  invalidPasswordUppercase: 'Password must contain at least one uppercase letter',
  invalidPasswordLowercase: 'Password must contain at least one lowercase letter',
  invalidPasswordNumber: 'Password must contain at least one number',
  invalidPasswordSpecialCharacter: 'Password must contain at least one special character',
  invalidPasswordLeadingTrailingSpace: 'Password cannot have leading or trailing whitespace',
  invalidName: '{{field}} cannot contain special characters',
  invalidInputAscend: '{{field}} must contain only letters, numbers, and simple symbols (, & - /)',
  invalidCode: 'Code must be exactly 6 digits',
  invalidEmail: 'Invalid email format',
  invalidPhoneNumber: 'Invalid phone number',
  invalidPhoneNumberAdmin: 'Phone number must be 10 digits and include +1 ',
  birthCountryError: 'While on visa, cannot set birth country to United States',
  citizenshipCountryError: 'While on visa, cannot set citizenship country to United States',
  invalidDate: 'Invalid date',
  duplicatedField: '{{type}} is already in use. Please use another one.',
  phoneNumberMismatch: 'The phone number does not match the selected country',
  phoneNumberFormatBR: 'The phone number must follow the format +55 (AA) 9NNNN-NNNN',
  areaCodeInvalid: 'The area code is not valid for the selected country',
  phoneNumberFormatInvalid: 'Invalid phone number format',
  phoneNumberFormatUS: 'The phone number must follow the format +1 (NNN) NNN-NNNN',
  imageFileRequired: 'Only PDF, JPEG, JPG, or PNG formats are supported',
  genericError: `We couldn’t process your request at this time. Please check your internet connection and try again. If this issue persists, please contact support at [{{ supportEmail }}]({{ supportEmail }}).`,
  wrongCode: 'The verification code you entered is incorrect.',
  noAddressProvided: 'Please provide an address',
  networkErrors: {
    noConnection: 'No internet connection',
    noConnectionBody:
      "It looks like you're having issues with your internet connection! Check your Wifi or cell service and try logging in again.",
    error413: 'Uploaded images are too big.',
    error415: 'Uploaded images have unsupported media type.',
    errorTitleDefault: 'Warning',
    errorBodyDefault:
      'An unexpected error has occurred and we couldn’t process your request at this time.',
  },
  genericErrorCodes: {
    CodeMismatchException: 'The verification code you entered is incorrect.',
    LimitExceededException:
      'You have exceeded the maximum number of attempts. Please try again later.',
    ExpiredCodeException: 'The verification code you entered has expired.',
  },
  transferErrors: {
    TRANSFER_ERROR_CODE_INSUFFICIENT_FUNDS:
      'Insufficient funds to complete the transfer. Please ensure you have enough balance.',
    TRANSFER_ERROR_CODE_UNAPPROVED:
      'Transfer is unapproved. Please contact support for assistance.',
    TRANSFER_ERROR_CODE_EXCEEDS_DAILY_LIMIT:
      'Transfer amount exceeds your daily limit. Please try again tomorrow.',
    TRANSFER_ERROR_CODE_INVALID_AMOUNT:
      'Invalid transfer amount. Please enter a valid amount and try again.',
    TRANSFER_ERROR_CODE_INVALID_ORDER:
      'Transfer order is invalid. Please review your transfer details and try again.',
    TRANSFER_ERROR_CODE_OTHER:
      'An unexpected error occurred during the transfer. Please try again later or contact support.',
    TRANSFER_ERROR_CODE_SERVER_ERROR:
      'An unexpected error occurred during the transfer. Please try again later or contact support.',
    TRANSFER_ERROR_CODE_INVALID_ACCOUNT_STATUS:
      'Transfer failed due to invalid account status. Please contact customer support for assistance.',
    TRANSFER_ERROR_CODE_UNSUPPORTED: 'An unexpected error occurred during the transfer.',
    TRANSFER_ERROR_CODE_VALIDATION_FAILED: 'An unexpected error occurred during the transfer.',
    accountInvalid: 'Please select a valid account',
    accountValidationFailed: 'Account validation failed',
    recurringDepositInvalid: 'Recurring deposit requires a valid interval and account',
  },
  wrongUsernameOrPassword: 'Your username or password are not correct. Please try again',
  onboardingTokenExpired:
    'Your verification token has expired. Please restart the process to continue.',
  tradeErrors: {
    amount: {
      underMin: 'Amount must be greater than or equal to {{minimumTradeAmount}}.',
      overMaxCash: 'Amount exceeds available cash.',
      overMaxHoldings: 'Amount exceeds available holdings.',
      maxNotionalValue: `Individual trades must be less than or equal to {{maxNotionalValue}}.`,
      maxOrderQuantity: `Individual trades must be less than or equal to {{maxOrderQuantity}} shares, this trade is estimated to be {{estimatedShares}} shares.`,
    },
    netAmount: {
      underMin: 'The net order total must be greater than {{minimumTradeAmount}}.',
    },
    mutualFund: {
      closedForNewInvestors:
        'This mutual fund is not available for purchase by new investors. For more information, contact Alight support.',
    },
  },
  sessionExpired: {
    title: 'You have been signed out.',
    description: "Please return to your organization's login page to access your accounts.",
  },
  invalidAddress: 'Invalid Address',
  cannotStartWithSpace: 'Cannot start with a space',
  invalidStateCode: 'Invalid State Code',
  invalidPostalCode: 'Invalid Postal Code',
  postalCodeExactLength: 'Postal Code must be exactly 5 digits',
  failedToUpdateTapToRetry: 'Failed to update. Tap to retry.',
};
